const QUALITIES: readonly Quality[] = ['ses', 'aes', 'qes', 'demo', 'aes_minimal', 'part11']

const LEGISLATIONS: readonly Legislation[] = ['any', 'zertes', 'eidas']

/**
 * Reduces a raw user attribute to a recognised value.
 *
 * This factors in potential legacy values that could be differently cased or arrayified.
 */
function canonicalise<T extends string>(value: unknown, allowed: readonly T[]): T | undefined {
  const candidate = Array.isArray(value) ? value[0] : value

  if (typeof candidate !== 'string') return undefined

  const normalised = candidate.toLowerCase() as T

  return allowed.includes(normalised) ? normalised : undefined
}

export default function useSigningDefaults() {
  const userStore = useUserStore()

  const quality = computed<Quality>(() => {
    return (
      canonicalise(userStore.attributes.defaultQuality, QUALITIES) ??
      canonicalise(userStore.highestSignatureQuality, QUALITIES) ??
      'ses'
    )
  })

  const legislation = computed<Legislation>(() => {
    const stored = canonicalise(userStore.attributes.defaultLegislation, LEGISLATIONS)

    if (stored) return stored

    const qualityData = userStore.signatureQualities[quality.value]

    return qualityData?.eidas ? 'eidas' : 'zertes'
  })

  const provider = computed<Provider>(() => {
    const qualityData = userStore.signatureQualities[quality.value]

    return qualityData?.any?.provider ?? qualityData?.eidas?.provider ?? qualityData?.zertes?.provider ?? ''
  })

  return { quality, legislation, provider }
}
